
<template>
  <v-layout row>
    <v-dialog v-model="cancelQADemo.dialog"
              max-width="600px">
        <v-card>
          <v-card-title class="title blue-title pa-3 pt-4 ml-2">
            Cancel the QA DEMO
            <div class="header-close" title="close" @click="cancelQADemo.dialog = false">
              <v-icon>close</v-icon>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="forms">
            <v-container grid-list-md px-2>
              <v-layout wrap>
                <v-flex xs12>
                  <v-flex xs12>
                      <v-subheader class="pa-0 form-title">Cancel Reason</v-subheader>
                  </v-flex>
                  <v-textarea v-model="reason"
                              outline
                              single-line 
                              counter="50"
                              maxLength="50"
                              ></v-textarea>
                  <p class="mb-0" style="color:rgba(50, 57, 122, 0.4)">*Please fill in the reason for cancellation, no more than 50 characters.</p>
                </v-flex>
              </v-layout>
            </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-layout justify-center>
                <v-btn 
                  class="text-none cancel-button"
                  @click="cancelQADemo.dialog = false">Cancel</v-btn>
              <v-btn 
                  class="text-none red-button dialog-submit"
                  :loading="loading"
                  @click="submit">Confirm</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { cancelQALessonInfo, cancelTestLesson } from '@/api/trainning.js'
export default {
  name: 'cancelQADemo',
  props: {
    cancelQADemo: {
      dialog: false,
      id:0,
      // eslint-disable-next-line vue/require-prop-type-constructor
      type:0
    }
  },
  data: () => ({
      reason:'',
      loading:false
  }),
  methods:{
      submit(){
        this.loading = true;
          if(this.cancelQADemo.type==4){
              cancelQALessonInfo(this.cancelQADemo.id,this.reason).then(res=>{
                let type = res.data.ErrorCode === 0 ? 'success' : 'error'
                this.$root.$alertTips(res.data.Msg, type).then(() => {
                    if (res.data.ErrorCode === 0) {
                        this.cancelQADemo.dialog = false;
                        this.$emit('func',true)
                    }
                })
              }).finally(()=>{
                this.loading = false;
              })
          }else if(this.cancelQADemo.type==5){
              cancelTestLesson(this.cancelQADemo.id,this.reason).then(res=>{
                    let type = res.data.ErrorCode === 0 ? 'success' : 'error'
                    this.$root.$alertTips(res.data.Msg, type).then(() => {
                        if (res.data.ErrorCode === 0) {
                            this.cancelQADemo.dialog = false;
                            this.$emit('func',true)
                        }
                    })
              }).finally(()=>{
                this.loading = false;
              })
          }
      }
  }
}
</script>
